import { styled } from "theme/default/styled";
import { setFontSize_14px } from "theme/setter/setFontSizeValues/setFontSize_14px";
import { setFontWeight400 } from "theme/setter/setFontWeightValues/setFontWeight400";

export const STerminalsFilterSelectTitle = styled.div`
  ${setFontSize_14px};
  ${setFontWeight400};
`;
